<script>
import appConfig from '@/app.config'
import TrackerVideo from './TrackerVideo'
import SideBar from './SideBar'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import { mapActions } from 'vuex'
import PageHeader from '@/components/page-header'

export default {
  name: 'TrackvideoIndex',
  page: {
    title: 'Trackvideo',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    SideBar,
    TrackerVideo,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      id: this.$route.params.id || null,
      expiresDays: null,
      expiresOn: null,
    }
  },

  computed: {
    title() {
      return this.$t('trackVideo.title')
    },
  },

  mounted() {
    this.$store.dispatch('layout/toggleMenu', true)
    this.$store.commit('video/clearFleet')
    this.$store.commit('video/resetPlaylist')
  },
  methods: {
    ...mapActions('video', ['setVideoStreamStatusOff']),
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button @click="$router.back()" variant="outline-primary" class="mx-2">
          <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>
    <div
      :class="{
        'card mc-liveview clearfix': $store.state.sidebar.sideBarOpen === true,
        'card mc-liveview clearfix close-sidebar': $store.state.sidebar.sideBarOpen === false,
      }"
      class="mt-4"
    >
      <TrackerVideo />
      <SideBar />
    </div>
  </Layout>
</template>
